import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'app-option-box',
  templateUrl: './option-box.component.html',
  styleUrls: ['./option-box.component.css']
})
export class OptionBoxComponent implements OnInit {

  public txt: string;
  public option1: string;
  public option2: string;

  constructor(public DialogRef: MatDialogRef<OptionBoxComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any) {
    if (data.txt) {
      this.txt = data.txt;
    }

    if (data.option1) {
      this.option1 = data.option1;
    }

    if (data.option2) {
      this.option2 = data.option2;
    }


  }



  ngOnInit(): void {

  }

  public Option1() {
    this.DialogRef.close(1);
  }

  public Option2() {
    this.DialogRef.close(2);
  }

}
